import FormattedMessage from 'I18n/components/FormattedMessage';
import { getDemo, getUserPermissionLevel
// @ts-expect-error upstream file not migrated
} from '../../../data/schemas/dashboardSchema';
import { DASHBOARD_IS_LOADING, IS_READ_ONLY_DEMO_DASHBOARD, DASHBOARD_PERMISSION_DENIED } from '../../problems';
// @ts-expect-error upstream file not migrated
import { useHasDemoDashboardWriteAccess } from '../../../access/scopes/hooks/useHasScope';
import { hasSufficientEditPermission } from '../../../permissions/permission-logic';
import { jsx as _jsx } from "react/jsx-runtime";
const useDeleteNonReportWidgetProblem = ({
  dashboard
}) => {
  const userCanWriteDemoDashboard = useHasDemoDashboardWriteAccess();
  const targetIsReadOnlyDemo = getDemo(dashboard) && !userCanWriteDemoDashboard;
  const dashboardPermissionDenied = !hasSufficientEditPermission(getUserPermissionLevel(dashboard));
  if (!dashboard) {
    return {
      problem: DASHBOARD_IS_LOADING,
      disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.nonReportWidgetActions.delete.tooltip.loading"
      })
    };
  } else if (targetIsReadOnlyDemo) {
    return {
      problem: IS_READ_ONLY_DEMO_DASHBOARD,
      disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.nonReportWidgetActions.delete.tooltip.readOnlyDemoDashboard"
      })
    };
  } else if (dashboardPermissionDenied) {
    return {
      problem: DASHBOARD_PERMISSION_DENIED,
      disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.nonReportWidgetActions.delete.tooltip.insufficientAssetPermission"
      })
    };
  }
  return {
    problem: null,
    disabledMessage: null
  };
};
export default useDeleteNonReportWidgetProblem;